import { Profiler, StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@fontsource/source-sans-3/300.css'
import '@fontsource/source-sans-3/400.css'
import '@fontsource/source-sans-3/500.css'
import '@fontsource/source-sans-3/600.css'
import '@fontsource/source-sans-3/700.css'
import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/open-sans/400.css'
import '@fontsource/open-sans/500.css'
import '@fontsource/open-sans/600.css'
import '@fontsource/open-sans/700.css'
import '@fontsource/ibm-plex-sans/300.css'
import '@fontsource/ibm-plex-sans/400.css'
import '@fontsource/ibm-plex-sans/500.css'
import '@fontsource/ibm-plex-sans/600.css'
import '@fontsource/ibm-plex-sans/700.css'
import '@fontsource/poppins/400.css'
import '@fontsource/poppins/500.css'
import '@fontsource/poppins/600.css'
import '@fontsource/poppins/700.css'
import '@fontsource/montserrat/400.css'
import '@fontsource/montserrat/500.css'
import '@fontsource/montserrat/600.css'
import '@fontsource/montserrat/700.css'
import './index.css'
import './ui/fg.css'
import './tableau/tableauParity.css'
import App from './App.tsx'
import { logRender } from './perf/profiler'
import { installDiagnosticConsoleCapture } from './utils/diagnosticConsole'
import { installConsoleFocus } from './utils/consoleFocus'
import { installDesktopDeepLinking } from './data/desktop/deepLinking'
import { isFuseGridNativeDesktopShell } from './data/desktop/isDesktop'

installDiagnosticConsoleCapture()
installConsoleFocus()

// Desktop-only: subscribe to `fusegrid://open?code=...` deep links and redeem open-intents.
void installDesktopDeepLinking()

// React (and some libraries) use the Performance User Timing APIs in dev.
// In large apps, `performance.measure()` can throw `DataCloneError` (OOM) and break UI updates.
// We treat this as non-fatal and swallow only that specific error.
if (typeof performance !== 'undefined' && typeof performance.measure === 'function') {
  const origMeasure = performance.measure.bind(performance)
  // @ts-ignore override for defensive dev patch
  performance.measure = (...args: any[]) => {
    try {
      // @ts-ignore forward args
      return origMeasure(...args)
    } catch (e: any) {
      const name = String(e?.name || '')
      if (name === 'DataCloneError') return
      throw e
    }
  }
}

createRoot(document.getElementById('root')!).render(
  (() => {
    const strictModeEnabled = (() => {
      // React StrictMode intentionally double-invokes mount/effects in development.
      // For local desktop imports this can duplicate heavyweight startup work.
      if (isFuseGridNativeDesktopShell()) return false
      return true
    })()
    const appTree = (
      <Profiler id="Root" onRender={logRender}>
        <App />
      </Profiler>
    )
    return strictModeEnabled ? <StrictMode>{appTree}</StrictMode> : appTree
  })(),
)
